import { Checkbox, FormGroup, FormGroupFeedback, IFormGroupProps, Intent } from '@pinpointhq/thumbtack';
import { FieldHelperProps, FieldInputProps, FieldMetaProps, useField, useFormikContext } from 'formik';
import * as React from 'react';

interface ICheckboxFieldProps {
  name: string;
  label: string;
  labelElement?: React.ReactNode;
  disabled?: boolean;
  submitOnChange?: boolean;
  formGroupProps?: Omit<IFormGroupProps, 'labelFor'>;
  handleChange?(): void;
}

export default function CheckboxField<T extends boolean>({
  handleChange,
  name,
  label,
  labelElement,
  disabled,
  submitOnChange,
  formGroupProps,
}: ICheckboxFieldProps) {
  const { submitForm } = useFormikContext();
  const [field, meta, helpers]: [FieldInputProps<T>, FieldMetaProps<T>, FieldHelperProps<T>] = useField<T>(name);
  const hasError = meta.touched && meta.error;

  const onCheckboxChange = (event: React.FormEvent<HTMLInputElement>) => {
    helpers.setValue(event.currentTarget.checked as T);
    if (handleChange) handleChange();
    if (submitOnChange) submitForm();
  };

  return (
    <FormGroup {...formGroupProps} labelFor={name}>
      <Checkbox onChange={onCheckboxChange} {...{ label, labelElement, disabled }} checked={field.value} />
      {hasError && <FormGroupFeedback intent={Intent.DANGER}>{meta.error}</FormGroupFeedback>}
    </FormGroup>
  );
}
